import { UserPlan } from '~/types/Plan';
import { PlanDetailsForTracking } from '~/selectors/plans.composite.selectors';

export type PlanLevel = 'trial' | 'basic' | 'pro' | 'premier';
export type PlanChangeType = 'upgraded' | 'downgraded' | 'cancelled' | 'same';

/**
 * Returns the plan level (basic, pro, premier) for a given plan display name.
 * @param planName
 */
export const getPlanType = (planName: string): PlanLevel => {
  if (planName.toLowerCase().includes('trial')) {
    return 'trial';
  }
  if (planName.toLowerCase().includes('pro')) {
    return 'pro';
  }
  if (planName.toLowerCase().includes('premier')) {
    return 'premier';
  }
  return 'basic';
};

/**
 * Shapes plan data into an event tracking payload
 * @param rawPlan
 */
export const planToTrackingDetails = (rawPlan: UserPlan): PlanDetailsForTracking => {
  return {
    plan_name: rawPlan.plan.name,
    plan_frequency: rawPlan.plan.billingFrequency,
    plan_start_date: rawPlan.startDate.toISOString(),
    plan_end_date: rawPlan.endDate?.toISOString() ?? null,
    plan_next_end_date: null,
    plan_next_bill_date: null,
    plan_cost: rawPlan.plan.subscriptionPrice,
    plan_label_estimate: rawPlan.plan.numberOfLabelsIncluded,
    plan_display_name: rawPlan.plan.displayName,
    plan_level: getPlanType(rawPlan.plan.displayName),
  };
};
